.aq{padding:0.5rem;}